module.exports = __webpack_public_path__ + "img/1547096542.7a49aa4b.jpg";